// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__bZF2a","unreadBadge":"styles_unreadBadge__1Niuv","modalContent":"styles_modalContent__1o63d","modal":"styles_modal__2sfyi"};